import { Fragment, useState, type InputHTMLAttributes } from 'react'
import type { Store } from '@sp/shared'
import { useSession } from '../session.tsx'
import { useOnline } from '../lib/useOnline.ts'
import { Icon } from './Icon.tsx'
import { Banner, IconButton, TextField } from './ui.tsx'

/** Drobne skladacky, ktere nejsou v design systemu, ale opakuji se na vic obrazovkach. */

export function Brand() {
  return (
    <div className="brand">
      <Icon name="basket" size={22} />
      <span>Sériové nákupy</span>
    </div>
  )
}

/** Obrazovky nakupu maji vlastni stav ukladani; tohle je pro zbytek appky. */
export function OfflineBanner() {
  const online = useOnline()
  const { state } = useSession()
  const offline = !online || (state.status === 'signed-in' && state.offline)
  if (!offline) return null
  return (
    <Banner tone="warning">
      <Icon name="wifi_off" size={18} />
      Bez připojení – vidíš poslední uložený stav.
    </Banner>
  )
}

/** „Biedronka Bogatynia → Kaufland Zittau" */
export function RouteLine({ stores }: { stores: readonly Store[] }) {
  if (stores.length === 0) return null
  return (
    <span className="route-line">
      {stores.map((store, i) => (
        <Fragment key={store.id}>
          {i > 0 && <Icon name="arrow_right" size={13} className="route-arrow" />}
          <span>{store.name}</span>
        </Fragment>
      ))}
    </span>
  )
}

export function PasswordField(
  props: { label: string; hint?: string | undefined } & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
) {
  const [visible, setVisible] = useState(false)
  return (
    <TextField
      {...props}
      type={visible ? 'text' : 'password'}
      trailingIsButton
      trailing={
        <IconButton
          icon="eye"
          tone="muted"
          label={visible ? 'Skrýt heslo' : 'Zobrazit heslo'}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
        />
      }
    />
  )
}

export function SyncStatus({ pending, offline }: { pending: number; offline: boolean }) {
  const label = offline ? (pending > 0 ? `Neodesláno: ${pending}` : 'Bez signálu') : pending > 0 ? 'Ukládám…' : 'Uloženo'
  return (
    <span className={`sync-status${offline ? ' is-offline' : ''}`} role="status">
      <Icon name={offline ? 'wifi_off' : pending > 0 ? 'refresh' : 'cloud_check'} size={18} />
      {label}
    </span>
  )
}
